import { HOME_DESKTOP_CONTENT_TOP_CLASS } from "@/lib/layout/homeDesktopRails";
import { cn } from "@/lib/utils";

export const HOME_FEED_RAIL_CLASS =
  "relative flex-1 min-w-0 px-2 sm:px-4 md:px-6 lg:px-8 pt-4 pb-4 md:pt-6 md:pb-6 max-w-2xl mx-auto w-full space-y-0 md:space-y-5 lg:right-[30px]";

export const ARAMLAS_HOME_RAIL_CLASS = cn(
  "flex flex-col flex-1 min-w-0 bg-white md:bg-transparent px-2 sm:px-4 md:px-6 lg:px-8 pt-0 lg:pt-6 pb-28 md:pb-8 gap-4 md:gap-6 max-w-2xl mx-auto w-full relative lg:right-[30px]",
  HOME_DESKTOP_CONTENT_TOP_CLASS,
);

export const ARAMLAS_HOME_BENTO_GRID_CLASS = "grid grid-cols-2 gap-3 sm:gap-4 md:gap-6";

export const ARAMLAS_HOME_BENTO_CLUSTER_CLASS = "flex flex-col gap-4 md:gap-6";

export const ARAMLAS_HOME_BENTO_CARD_SQUARE_CLASS =
  "aspect-square rounded-[2.5rem]";

export const ARAMLAS_HOME_BENTO_CARD_TALL_CLASS =
  "aspect-square md:aspect-auto md:h-[280px] rounded-[2.5rem]";

/** Locked mobile bento tile — sub-md home parity. */
export const ARAMLAS_HOME_BENTO_CARD_MOBILE_TALL_CLASS =
  "aspect-square rounded-[2.5rem]";

/** DailyMessageHero compact shell — keep skeleton and live hero in sync. */
export const ARAMLAS_HOME_DAILY_MESSAGE_COMPACT_CLASS =
  "min-h-[220px] w-full rounded-[2.5rem] sm:min-h-[260px] md:min-h-[220px]";

export const ARAMLAS_HOME_DAILY_MESSAGE_COMPACT_SHELL_CLASS =
  "overflow-hidden flex flex-col justify-center bg-white shadow-[inset_0_0_0_1px_rgba(0,0,0,0.06),inset_0_0_24px_rgba(0,0,0,0.10)]";

export const ARAMLAS_HOME_GREETING_CARD_BACKGROUND_URL =
  "/backgrounds/aramlas-home-greeting-card-vintage.webp";

/** Evergreen Áramlás home hero shell — artwork rendered via <img> in DailyMessageHero. */
export const ARAMLAS_HOME_DAILY_MESSAGE_EVERGREEN_SHELL_CLASS = cn(
  "relative overflow-hidden flex flex-col justify-center",
);

export const ARAMLAS_HOME_DAILY_MESSAGE_EVERGREEN_SCRIM_CLASS =
  "pointer-events-none absolute inset-0 z-[1] bg-[radial-gradient(ellipse_88%_72%_at_50%_48%,rgba(52,18,12,0.22)_0%,rgba(52,18,12,0.08)_48%,transparent_74%)]";

export const ARAMLAS_HOME_CALENDAR_WRAPPER_CLASS = "w-full";

export const aramlasHomeWidgetViewAllClass = (isBright: boolean) =>
  cn(
    "inline-flex min-h-[44px] items-center gap-1 rounded-full px-3.5 text-[13px] font-medium",
    isBright ? "text-[#86868B]" : "text-white/45",
  );

/** Mirrors Home.tsx bento slot order: tagság, podcast, liveok, jelenlet, exkluzív, alvás, surprise, folytasd. */
export const ARAMLAS_HOME_BENTO_SKELETON_SLOTS = [
  "square",
  "tall",
  "tall",
  "tall",
  "tall",
  "tall",
  "tall",
  "tall",
] as const;
